import { ursaColors } from "@smartsheet/design-tokens";
import React, { forwardRef, Ref } from "react";
import { GeneratedIconProps } from "../../icon/GeneratedIconProps";
import { Icon } from "../../icon/Icon";
import ProgressBarSvg from "./ProgressBarSvg";

type Enumerate<N extends number, Acc extends number[] = []> = Acc["length"] extends N
    ? Acc[number]
    : Enumerate<N, [...Acc, Acc["length"]]>;

export type Range<F extends number, T extends number> = Exclude<Enumerate<T>, Enumerate<F>>;

export interface ProgressBarIconProps extends GeneratedIconProps {
    /** Automatically set the fill based on value. */
    value: Range<0, 101>;
    /** The `color` prop will handle the main (blue) fill, but if you need to change the white unfilled color, use this prop. */
    emptyFillColor?: string;
    /**
     * The size to render the icon at.
     */
    size?: {
        height: number | string;
        width: number | string;
    };
}

export const ProgressBarIcon = forwardRef(
    (
        {
            color = ursaColors.azure400,
            emptyFillColor = ursaColors.neutral00,
            size,
            value,
            ...rest
        }: ProgressBarIconProps,
        ref: Ref<HTMLElement>
    ) => {
        const finalSize = {
            width: size?.width ? Number(size.width) : 71,
            height: size?.height ? Number(size.height) : 20,
        };

        return (
            <Icon color={color} size={finalSize} ref={ref} {...rest}>
                <ProgressBarSvg value={value} size={finalSize} emptyFillColor={emptyFillColor} />
            </Icon>
        );
    }
);
ProgressBarIcon.displayName = "ProgressBarIcon";
